export enum EProjectSettingsField {
  HEADER_COLOR = 'header_color',
  BUTTONS_COLOR = 'buttons_color',
  MAX_TRACKERS = 'max_trackers',
  DEFAULT_CREATIVE_ID = 'deafult_creative_id',
  DEFAULT_ADVERTISING_COMPANY_ID = 'default_advertising_company_id',
  DEFAULT_SERIAL_ID = 'deafult_serial_id',
  COMPANY_NAME = 'company_name',
  CURRENT_DEFAULT_CONDITION_ID = 'current_default_condition_id',
  CURRENT_DEFAULT_SUBAFFILIATE_CONDITION_ID = 'current_default_subaffiliate_condition_id',
  TITLE = 'title',
  CURRENCY = 'currency',
  DEFAULT_LOCALE = 'default_locale',
  CREATIVE_DEFAULT_DOMAIN = 'creative_default_domain',
  INTERFACE_LOCALES = 'interfaceLocales',
  CREATIVE_LOCALES = 'creativeLocales',
}
